import { createContext } from "react";

export const paiementContext = createContext();
export const depenseContext = createContext();
export const eleveContext = createContext();
export const personnelContext = createContext();
export const parentContext = createContext();
